import { Store } from "pullstate";

export const CheckoutStepState = new Store(0);
